import React from 'react'

export default function DashboardCard({ available, icon, title, percent }) {
  return (
    <div className='font-poppins group'>
      <div className="relative flex flex-col p-8 rounded-[2rem] bg-white border border-gray-100 shadow-[0_10px_40px_rgba(0,0,0,0.02)] transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.05)] hover:-translate-y-2 overflow-hidden">
        {/* Decorative Background Blob */}
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-premium-teal/5 rounded-full blur-3xl group-hover:bg-premium-gold/10 transition-colors duration-500"></div>

        <div className="flex justify-between items-start relative z-10">
          <div className="flex-grow">
            <p className="text-[10px] font-black text-premium-gold uppercase tracking-[0.2em] mb-2">{title}</p>
            <h2 className="text-5xl font-black text-premium-teal tracking-tighter mb-1 animate-fade-in-up">
              {available}
            </h2>
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-bold text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full uppercase tracking-widest">{percent || 'Units'}</span>
              <div className="w-8 h-[2px] bg-premium-gold/30 rounded-full"></div>
            </div>
          </div>

          <div className="w-16 h-16 rounded-2xl bg-premium-teal/5 flex items-center justify-center text-premium-teal transition-all duration-500 group-hover:bg-premium-teal group-hover:text-white group-hover:rotate-6 shadow-sm">
            {React.cloneElement(icon, { size: 28, className: "transition-colors duration-500" })}
          </div>
        </div>

        {/* Subtle Bottom Line */}
        <div className="mt-8 w-full h-1.5 bg-gray-50 rounded-full overflow-hidden">
          <div className="w-1/3 h-full bg-gradient-to-r from-premium-gold to-premium-gold-light rounded-full group-hover:w-1/2 transition-all duration-1000"></div>
        </div>
      </div>
    </div>
  )
}
